// Arquivo: src/lib/dashboardApi.ts  (colar o conteúdo INTEGRAL no Code Mode)
// Adapter único das Functions. Leitura 100% por get-dashboard (somente dados
// publicados); sync por request-sienge-sync; Copilot por ask-rdr-copilot.
// O frontend NUNCA acessa staging nem coleções diretamente.

import { lumi } from '@/lib/lumi'
import type {
  DashboardResponse,
  DataFilters,
  DetailPage,
  FiltersInfo,
  InsumosResponse,
  JobInfo,
  SnapshotResponse,
  TreeResponse,
} from '@/domain/engineering'

type Payload = Record<string, unknown>
type FunctionError = { message?: string; error?: string }

export async function invokeFunction<T>(name: string, body?: Payload): Promise<T> {
  try {
    return await lumi.functions.invoke(name, { method: 'POST', body }) as T
  }
  catch (reason) {
    const payload = reason as FunctionError
    throw new Error(payload?.message ?? payload?.error ?? 'A função do Lumi não pôde concluir a solicitação.')
  }
}

export interface DetailParams extends DataFilters {
  limit: number
  offset: number
  busca?: string
}

export interface InsumosParams extends DataFilters {
  codigo?: string
  termo?: string
  origem?: string
}

export const dashboardApi = {
  snapshot(): Promise<SnapshotResponse> {
    return invokeFunction<SnapshotResponse>('get-dashboard', { action: 'snapshot' })
  },

  filters(): Promise<FiltersInfo> {
    return invokeFunction<FiltersInfo>('get-dashboard', { action: 'filters' })
  },

  dashboard(filters: DataFilters): Promise<DashboardResponse> {
    return invokeFunction<DashboardResponse>('get-dashboard', { action: 'dashboard', ...filters })
  },

  tree(filters: DataFilters): Promise<TreeResponse> {
    return invokeFunction<TreeResponse>('get-dashboard', { action: 'tree', ...filters })
  },

  insumos(params: InsumosParams): Promise<InsumosResponse> {
    return invokeFunction<InsumosResponse>('get-dashboard', { action: 'insumos', ...params })
  },

  detail(params: DetailParams): Promise<DetailPage> {
    return invokeFunction<DetailPage>('get-dashboard', { action: 'detail', ...params })
  },

  job(jobId: string): Promise<{ job: JobInfo | null }> {
    return invokeFunction<{ job: JobInfo | null }>('get-dashboard', { action: 'job', jobId })
  },

  requestSync(): Promise<{ jobId: string; runId: string; status: string }> {
    return invokeFunction<{ jobId: string; runId: string; status: string }>('request-sienge-sync')
  },

  askCopilot(question: string, contextObra?: string): Promise<{ reply: string; tools_used?: Array<{ tool: string }> }> {
    return invokeFunction<{ reply: string; tools_used?: Array<{ tool: string }> }>('ask-rdr-copilot', { question, context: contextObra ? { obra: contextObra } : undefined })
  },
}
